<template>
  <div class="card-body mb-3" @click.self="handleClickOutside">
    <template v-if="!isImput">
      <div class="dropdown float-end" v-if="userAdmin === 1">
        <a 
          @click="toggleDropdown"
          class="dropdown-toggle arrow-none"
          data-bs-toggle="dropdown"
          aria-expanded="false">
          <i class="mdi mdi-dots-vertical m-0 text-muted h5"></i>
        </a>
        <div class="dropdown-menu dropdown-menu-end" :class="{ 'show': dropDow }">
          <a class="dropdown-item" @click="toggleInput"><i class="mdi mdi-square-edit-outline"></i> Editar</a>
          <a class="dropdown-item" v-if="position > 0" @click="moveBucket('up')"><i class="mdi mdi-arrow-left"></i> Mover para esquerda</a>
          <a class="dropdown-item" v-if="total > position" @click="moveBucket('down')"><i class="mdi mdi-arrow-right"></i> Mover para direita</a>
          <a class="dropdown-item" @click="deleteBucket"><i class="mdi mdi-delete-outline "></i> Apagar</a>
        </div>
      </div>
      <h4 class="card-title mb-0 font-15">{{ bucket.name | limited(30) }}</h4>
    </template>

    <div class="input-group input-group-outline input-add" v-else>
      <input type="text" v-model="bucket.name" class="form-control" />
      <button type="button" class="btn btn-primary" @click="setBucketName">OK</button>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    bucket: { type: Object, default: () => [] },
    position: { type: Number, default: 0 },
    total: { type: Number, default: 0 },
    userAdmin: { type: Number, default: 0 }
  },
  data() {
    return {
      isImput: false,
      bucketName: null,
      dropDow: false,
    };
  },
  methods: {
    toggleDropdown() {
      this.dropDow = !this.dropDow;
    },
    toggleInput() {
      this.isImput = !this.isImput;
      this.dropDow = false; // Fecha o dropdown ao editar
    },
    moveBucket(direction) {
      this.$emit('moveBucket', this.bucket.id, direction);
      this.dropDow = false;
    },
    deleteBucket() {
      this.$emit('deleteBucket', this.bucket.id);
      this.dropDow = false;
    },
    setBucketName() {
      this.$emit('setBucketName', this.bucket);
      this.isImput = false;
    },
    handleClickOutside(event) {
      if (!this.$el.contains(event.target)) {
        this.dropDow = false;
      }
    }
  },
  mounted() {
    // Adiciona o event listener ao montá-lo
    document.addEventListener('click', this.handleClickOutside);
  },
  beforeDestroy() {
    // Remove o event listener após a destruição do componente
    document.removeEventListener('click', this.handleClickOutside);
  }
};
</script>

<style scoped>
.dropdown-menu.show {
  position: absolute;
  margin: 0px;
  padding: 0px;
  transform: translate3d(0px, 23px, 0px);
  top:25px !important;
  right: -20px;
}

.dropdown-item{
  padding: 0.55rem;
}
</style>